import React from "react";
import { useParams } from "react-router-dom";
import {
 apiCallPost,
 calculateCost,
 indianRupee,
 niceDate,
 niceDateTime,
 renderQuantityNice,
 transposeDioptre,
} from "../util/util";
import "../Order.css";
import QRCode from "react-qr-code";
import { Button, H4, NonIdealState, Spinner } from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import _ from "lodash";

function withRouter(Component) {
 function ComponentWithRouter(props) {
  let params = useParams();
  return <Component {...props} params={params} />;
 }
 return ComponentWithRouter;
}

class OPJobLowerOrder extends React.Component {
 state = {
  isLoading: true,
  isFailure: false,
  orderId: null,
  hasLoaded: false,
 };
 componentDidMount() {
  let ss = this.props.params.orderId;
  this.setState({ orderId: ss });
  if (ss) {
   this.getSubmission(ss);
  } else {
   this.setState({ isLoading: false, isInvalid: true });
  }
 }
 getSubmission = async (ss) => {
  try {
   let res = await apiCallPost("/print/ims2OpticalJob", {
    _id: ss,
   });
   const hasBalance =
    Math.trunc(res.totalPaidAmountPaise / 100) <
    Math.trunc(res.totalAmountPaise / 100);

   const totalDiscountAmountPaise = res.paymentHistory
    .filter((ph) => ph.paymentType === "Discount")
    .map((ph) => ph.paidAmountPaise)
    .reduce((a, b) => a + b, 0);

   const totalCashAmountPaise =
    res.totalPaidAmountPaise - totalDiscountAmountPaise;

   console.log({
    hasBalance,
    totalDiscountAmountPaise,
    totalCashAmountPaise,
   });

   this.setState(
    {
     isLoading: false,
     hasLoaded: true,
     ...res,
     hasBalance,
     totalDiscountAmountPaise,
     totalCashAmountPaise,
    },
    () => {
     document.title = `${this.state.customerName} - ${this.state.entityName}`;
    }
   );
  } catch (err) {
   cogoToast.error("Failed to load optical order data.");
   this.setState({ isLoading: false, isFailure: true });
  }
 };

 renderHeader = () => {
  return (
   <div>
    <div
     style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
     }}
    >
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
       }}
      >
       <img
        alt="Client Logo"
        src={
         this.state.branchInfo.opticalStoreLogo || this.state.branchInfo.logoUrl
        }
        height="85px"
        width="auto"
        className="img_block"
       />
       <b
        style={{
         fontSize: "9pt",
         marginTop: "3px",
         maxWidth: "120px",
         textAlign: "center",
        }}
       >
        {this.state.branchInfo.opticalStoreName ||
         this.state.branchInfo.hospital_name}
       </b>
      </div>
      <div>
       <div style={{ textAlign: "left" }}>
        {this.renderHorizontalText("OPTICAL STORE WORK ORDER")}
       </div>
       <b>
        {this.state.branchInfo.opticalStoreName ||
         this.state.branchInfo.hospital_contact[0]}
       </b>
       <br />
       {this.state.branchInfo.hospital_contact[1]} <br />
       {this.state.branchInfo.hospital_contact[2]} <br />
       {this.state.branchInfo.hospital_contact[3]} <br />
       {this.state.branchInfo.opticalStorePh
        ? [`Optical Store: ${this.state.branchInfo.opticalStorePh}`, <br />]
        : null}
       --------------------------------- <br />
       On Behalf Of: <br />
       <b>{this.state.customerPID || ""}</b> <br />
       <b>{this.state.customerName || ""}</b> <br />
       {this.state.customerPhone || ""} <br />
       {this.state.customerAddress || ""} <br />
       {this.state.customerGst ? `GST: ${this.state.customerGst}` : null}
       {this.state.deliveryDate ? (
        <>
         <br />
         Delivery Date : {niceDate(this.state.deliveryDate)}
        </>
       ) : null}
      </div>
     </div>{" "}
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
       textAlign: "right",
       marginRight: "10px",
      }}
     >
      <div
       style={{
        marginLeft: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "space-between",
        textAlign: "right",
        maxWidth: "200px",
       }}
      >
       <div>
        <H4>{this.state.entityName}</H4>
       </div>
       <div>
        {niceDateTime(this.state.updatedAt)}
        <br />
        {this.state.vendor.entityName} <br /> {this.state.vendor.GSTIN || ""}
        <br />
        {(this.state.vendor.vendorContacts || [])
         .map((c) => c.email)
         .join(", ")}
        <br />
        {this.state.vendor.principal_place_address}
       </div>
      </div>
      <div
       style={{
        marginLeft: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
       }}
      >
       <QRCode
        size={80}
        value={`https://print.newchart.care/optical/${this.props.params.orderId}`}
        level="H"
       />
       <div
        style={{
         fontSize: "x-small",
         wordBreak: "break-all",
         maxWidth: "150px",
         textAlign: "center",
        }}
       >
        <code> {this.state.orderId}</code>
       </div>
      </div>
     </div>
    </div>
   </div>
  );
 };

 renderPower = () => {
  return (
   <div>
    <div>{this.renderHorizontalText("Prescription")}</div>
    <table
     className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
     style={{ marginLeft: "auto", marginRight: "auto" }}
    >
     <thead>
      <tr>
       <th>Eye</th>
       <th>Sph</th>
       <th>Cyl</th>
       <th>Axis</th>
       <th>Add</th>
       <th>PD</th>
       <th>FH</th>
       <th>SH</th>
       <th>DIA</th>
      </tr>
     </thead>
     <tbody>
      <tr>
       <td>RE</td>
       <td>{this.state.refractionDetails.re.sph || ""}</td>
       <td>{this.state.refractionDetails.re.cyl || ""}</td>
       <td>{this.state.refractionDetails.re.axis || ""}</td>
       <td>{this.state.refractionDetails.re.add || ""}</td>
       <td>{this.state.refractionDetails.re.pd || ""}</td>
       <td>{this.state.refractionDetails.re.fh || ""}</td>
       <td>{this.state.refractionDetails.re.sh || ""}</td>
       <td>{this.state.refractionDetails.re.dia || ""}</td>
      </tr>
      <tr>
       <td>LE</td>
       <td>{this.state.refractionDetails.le.sph || ""}</td>
       <td>{this.state.refractionDetails.le.cyl || ""}</td>
       <td>{this.state.refractionDetails.le.axis || ""}</td>
       <td>{this.state.refractionDetails.le.add || ""}</td>
       <td>{this.state.refractionDetails.le.pd || ""}</td>
       <td>{this.state.refractionDetails.le.fh || ""}</td>
       <td>{this.state.refractionDetails.le.sh || ""}</td>
       <td>{this.state.refractionDetails.le.dia || ""}</td>
      </tr>
     </tbody>
    </table>
   </div>
  );
 };

 renderTotal = () => {
  let total = 0;
  if (!this.state.items) {
   return total;
  }
  if (!this.state.items.length) {
   return total;
  }
  for (var i = 0; i < this.state.items.length; i++) {
   let each = this.state.items[i];
   total += calculateCost(
    each.itemSalePrice,
    each.itemSalePriceGst,
    each.inventoryDetails.quantity,
    each.inventoryDetails.subunitOfConsumption
   );
  }
  return total;
 };

 renderItems = () => {
  return (
   <div>
    <div>{this.renderHorizontalText("ITEMS")}</div>
    <table
     className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
     style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
    >
     <thead>
      <tr>
       <th>#</th>
       <th>Item</th>
       <th>Quantity</th>
      </tr>
     </thead>
     <tbody>{this.renderEachItem()}</tbody>
     <tfoot>
      {/* <tr>
              <td colSpan={6} style={{ textAlign: "right" }}>
                <b> Total</b>
              </td>
              <td colSpan={3}>
                <b>{indianRupee(this.renderTotal())}</b>
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ textAlign: "right" }}>
                <b> Discount</b>
              </td>
              <td colSpan={3}>
                <b>{indianRupee(this.state.totalDiscountAmountPaise || 0)}</b>
              </td>
            </tr>
            <tr>
              <td colSpan={6} style={{ textAlign: "right" }}>
                <b> Paid</b>
              </td>
              <td colSpan={3}>
                <b>{indianRupee(this.state.totalCashAmountPaise || 0)}</b>
              </td>
            </tr> */}

      {this.state.hasBalance ? (
       <tr>
        <td colSpan={6} style={{ textAlign: "right" }}>
         <b> Balance </b>
        </td>
        <td colSpan={3}>
         <b>
          {indianRupee(
           this.state.totalAmountPaise - this.state.totalPaidAmountPaise
          )}
         </b>
        </td>
       </tr>
      ) : null}

      <td colSpan={9} style={{ textAlign: "left" }}>
       <b> LE LensType: </b> {this.state.LELensType || "<None>"}
       <br />
       <b> RE LensType: </b> {this.state.RELensType || "<None>"}
       <br />
       <b> Other Notes: </b> {this.state.orderNotes || "<None>"}
      </td>
     </tfoot>
     {/* <tfoot>
            <tr>
              <td colSpan={9} style={{ textAlign: "left" }}>
                <b> Other Notes: </b> {this.state.orderNotes || "<None>"}
              </td>
            </tr>
          </tfoot> */}
    </table>
   </div>
  );
 };

 renderEachItem = () => {
  if (!this.state.items) {
   return null;
  }
  if (!this.state.items.length) {
   return null;
  }
  return this.state.items.map((each, index) => {
   return (
    <tr>
     <td>{index + 1}</td>
     <td>
      <>{each.itemName}</>
      <>
       {each.itemLensEye ? (
        <>
         <br />
         <b>{each.itemLensEye} </b>|{" "}
         {
          transposeDioptre({
           sphere:
            this.state.refractionDetails[_.lowerCase(each.itemLensEye)].sph,
           cylinder:
            this.state.refractionDetails[_.lowerCase(each.itemLensEye)].cyl,
           axis:
            this.state.refractionDetails[_.lowerCase(each.itemLensEye)].axis,
           near:
            this.state.refractionDetails[_.lowerCase(each.itemLensEye)].add,
           pd: this.state.refractionDetails[_.lowerCase(each.itemLensEye)].pd,
          }).string
         }
        </>
       ) : null}
      </>
     </td>

     <td>
      {renderQuantityNice(
       each.inventoryDetails.quantity,
       each.inventoryDetails.subunitOfConsumption,
       each.itemUnitName,
       each.itemSubunitName
      )}
     </td>
    </tr>
   );
  });
 };

 renderTermsAndFooter = () => {
  return (
   <div>
    <div
     style={{
      display: "flex",
      fontSize: "x-small",

      justifyContent: "space-between",
     }}
    >
     <div
      style={{
       display: "flex",
       justifyContent: "space-between",
      }}
     >
      <div
       style={{
        display: "flex",

        justifyContent: "flex-start",
       }}
      >
       <div
        style={{
         marginRight: "5px",
         marginBottom: "5px",
         display: "flex",
         flexDirection: "column",
         alignItems: "flex-start",
         justifyContent: "flex-start",
         maxWidth: "200vw",
        }}
       >
        <div style={{ textAlign: "left" }}>
         1. Delivery date of spectacle is an approximate estimated date only &
         may differ.
        </div>
        <div style={{ textAlign: "left" }}>
         3. A minimum advance payment of 40% of the order value is required for
         order processing.
        </div>
        <div style={{ textAlign: "left" }}>
         5. Items once sold cannot be returned or refunded.
        </div>
        <div style={{ textAlign: "left" }}>
         7. Lenses are warranted for power changes and any manufacturing defects
         for a period of 3 months.
        </div>
        <div style={{ textAlign: "left" }}>
         {this.state.lifecycle === "DISPENSED"
          ? "Any repair or replacement of frames/lenses under warranty would be completed within 15 days, subject to availability."
          : "9. Any non-collected items/orders after a period of 60 days will be returned to the company, and any amount paid will be forfeited."}
        </div>
       </div>
       <div
        style={{
         marginRight: "5px",
         marginBottom: "5px",
         display: "flex",
         flexDirection: "column",
         alignItems: "flex-start",
         justifyContent: "flex-start",
         maxWidth: "70vw",
        }}
       >
        <div style={{ textAlign: "left" }}>
         2. Orders once placed cannot be modified or cancelled.
        </div>

        <div style={{ textAlign: "left" }}>
         4. Customer’s own frames and lenses are handled at the customer’s risk.
        </div>

        <div style={{ textAlign: "left" }}>
         6. Frames priced under Rs.1000 are warranted only for manufacturing
         defects for a period of 6 months, frames priced above Rs.1000 are
         warranted only for manufacturing defects for 12 months.
        </div>

        <div style={{ textAlign: "left" }}>
         8. For product replacement under warranty, similar model, colour, and
         price range will be provided in case of product unavailability.
        </div>

        <div style={{ textAlign: "left" }}>
         10. The above terms are subject to change at the discretion of the
         management without prior notice.
        </div>
       </div>
       <div
        style={{
         marginRight: "5px",
         marginBottom: "5px",
         display: "flex",
         flexDirection: "column",
         alignItems: "flex-end",
         justifyContent: "flex-start",
         maxWidth: "40vw",
        }}
       >
        <div style={{ textAlign: "right" }}>
         {this.renderHorizontalText("E. & O. E.")}
        </div>
        <div style={{ textAlign: "right" }}>
         This is a computer generated invoice and does not require a signature.
        </div>
        <div style={{ textAlign: "right" }}>
         In case of queries, please reach out to us.
        </div>
       </div>
      </div>{" "}
     </div>
    </div>
   </div>
  );
 };

 renderVerticalText = (text, isProminent = true) => {
  return (
   <div
    style={{
     textAlign: "center",
     backgroundColor: "#E6E7E7",
     textOrientation: "upright",
     writingMode: "vertical-rl",
     marginRight: "10px",
     fontSize: "xx-small",
     border: `${isProminent ? "1px solid black" : ""}`,
    }}
   >
    {isProminent ? <b>{text}</b> : <>{text}</>}
   </div>
  );
 };
 renderHorizontalText = (text, isProminent = false) => {
  return (
   <div
    style={{
     textAlign: "center",
     backgroundColor: "#E6E7E7",
     marginBottom: "10px",
     fontSize: "xx-small",
     letterSpacing: "1mm",

     border: `${isProminent ? "1px solid black" : ""}`,
    }}
   >
    {isProminent ? <b>{text}</b> : <>{text}</>}
   </div>
  );
 };

 render() {
  if (this.state.isLoading) {
   return (
    <div className="center_screen">
     <NonIdealState icon={<Spinner />} title="Loading..." />
    </div>
   );
  }
  if (this.state.isFailure) {
   return (
    <div className="center_screen">
     <NonIdealState
      icon="warning-sign"
      title="We ran into an error. If you face this problem multiple times, please contact support."
     />
    </div>
   );
  }
  if (!this.state.hasLoaded) {
   return (
    <div className="center_screen">
     <NonIdealState
      icon="warning-sign"
      title="We ran into an error. If you face this problem multiple times, please contact support."
     />
    </div>
   );
  }
  return (
   <div
    className="rx__container"
    style={{
     display: "flex",
     flexDirection: "column",
     justifyContent: "space-between",
    }}
   >
    {" "}
    <style type="text/css" media="print">
     {" @page { size: A4 landscape !important; margin: 7mm !important;"}
    </style>
    <div>
     <div className="no__print">
      <Button
       icon="print"
       text="Print"
       onClick={() => {
        window.print();
       }}
       fill
      />
      <br />
      <br />
     </div>
     {this.renderHeader()}
     <hr />
     {this.renderPower()}
     <hr />
     {this.renderItems()}
     <hr />
    </div>
    <div style={{ position: "fixed", bottom: "0", width: "100vw" }}>
     {this.renderTermsAndFooter()}
    </div>
   </div>
  );
 }
}

const OpticalJob = withRouter(OPJobLowerOrder);
export default OpticalJob;
